import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import {
  Box,
  Paper,
  Typography,
  Divider,
  MenuItem,
  Select,
  Grid,
  FormControl,
  InputLabel,
} from "@mui/material";

const dayLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function generateCalendarMatrix(durationsMap, year, month) {
  const totalDays = new Date(year, month, 0).getDate();

  const matrix = [];
  const texts = [];

  let week = new Array(7).fill(null);
  let weekText = new Array(7).fill("");

  for (let day = 1; day <= totalDays; day++) {
    const date = new Date(year, month - 1, day);
    const dayOfWeek = date.getDay();

    week[dayOfWeek] = durationsMap[day] ?? 0;
    weekText[dayOfWeek] = `${day}`;

    if (dayOfWeek === 6 || day === totalDays) {
      matrix.push([...week]);
      texts.push([...weekText]);
      week = new Array(7).fill(null);
      weekText = new Array(7).fill("");
    }
  }

  return { z: matrix, text: texts };
}

const monthOptions = Array.from({ length: 12 }, (_, i) => ({
  label: new Date(0, i).toLocaleString("default", { month: "long" }),
  value: i + 1,
}));
export default function MonthlyHeatmapPlot({ data = {}, selectedMonth, onMonthChange }) {
  const currentYear = new Date().getFullYear();
  const [month, setMonth] = useState(selectedMonth);

  useEffect(() => {
    setMonth(selectedMonth);
  }, [selectedMonth]);

  const handleMonthChange = (e) => {
    const newMonth = e.target.value;
    setMonth(newMonth);
    onMonthChange(newMonth);
  };

  const hasData = Object.keys(data).length > 0;

  return (
    <Box mt={3}>
      <Grid container spacing={2} alignItems="center" mb={3}>
        <Grid item>
          <FormControl size="large">
            <InputLabel>Month</InputLabel>
            <Select value={month} label="Month" onChange={handleMonthChange}>
              {monthOptions.map((m) => (
                <MenuItem key={m.value} value={m.value}>
                  {m.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      {!hasData ? (
        <Typography variant="body1" color="textSecondary" sx={{ mt: 4 }}>
          No data available for the selected month.
        </Typography>
      ) : (
        Object.entries(data).map(([billboardId, billboardData]) => {
          const { durations_by_day } = billboardData;
          const { z, text } = generateCalendarMatrix(durations_by_day, currentYear, month);

          return (
            <Paper
              key={billboardId}
              elevation={4}
              sx={{ p: 3, mb: 4, borderRadius: 3, backgroundColor: "#f9f9f9" }}
            >
              <Typography variant="h6" sx={{ mb: 2, color: "primary.main", fontWeight: 600 }}>
                Billboard: {billboardId} - {billboardData.location} ({billboardData.height} x {billboardData.width})
              </Typography>
              <Divider sx={{ mb: 2 }} />

              <Plot
                data={[
                  {
                    z,
                    x: dayLabels,
                    y: Array.from({ length: z.length }, (_, i) => `Week ${i + 1}`),
                    text,
                    type: "heatmap",
                    hovertemplate: "Day %{text}<br>Duration: %{z}<extra></extra>",
                    texttemplate: "%{text}", // <- SHOWS THE MONTH-DAY INSIDE BOX
                    colorscale: "Reds",
                    showscale: true,
                  }
                ]}
                layout={{
                  height: 300,
                  margin: { t: 30, l: 60, r: 20, b: 60 },
                  paper_bgcolor: "#fff",
                  plot_bgcolor: "#fff",
                }}
                useResizeHandler
                style={{ width: "100%", height: "100%" }}
                config={{ displayModeBar: true, displaylogo: false }}
              />
            </Paper>
          );
        })
      )}
    </Box>
  );
}